const couponType = {
  Amount: 1,
  Percent: 2
}

export default couponType;